export function formatPersonName(firstName = "", lastName = "") {
  return `${firstName} ${lastName}`.trim();
}
